import { C } from './constants';

/**
 * Pill-shaped tab/toggle button.
 *
 * @param {React.ReactNode} children - Label text
 * @param {boolean} active - Whether selected
 * @param {Function} onClick - Click handler
 * @param {string} [color=C.gold] - Accent color when active
 */
export const Pill = ({ children, active, onClick, color = C.gold }) => (
  <button onClick={onClick} style={{
    padding: '6px 16px',
    borderRadius: 100,
    border: `1px solid ${active ? color + '44' : C.border}`,
    cursor: 'pointer',
    background: active ? color + '12' : 'transparent',
    color: active ? color : C.t3,
    fontSize: 12,
    fontWeight: 500,
    transition: 'all .3s',
    letterSpacing: 0.3,
  }}>
    {children}
  </button>
);
